module.exports = __webpack_public_path__ + "img/x5_dc3fe6093.png";